export const navTitles = {
  "/call": "Select Apartment",
  "/residents": "Select Residents",
};
